<template>
  <div>
    <el-form-item :label="$t('最高级别')">
      <l-select
        placeholder="请输入最高级别"
        :options="options"
        :clearable="false"
        v-model="value"
      ></l-select>
    </el-form-item>
    <el-form-item :label="$t('是否可见')">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-secretLevel",
  props: ["data"],
  data() {
    return {
      options: [
        { value: 1, label: this.$t("公开") },
        { value: 2, label: this.$t("内部") },
        { value: 3, label: this.$t("秘密") },
        { value: 4, label: this.$t("机密") },
        { value: 5, label: this.$t("绝密") },
      ],
    };
  },
  computed: {
    value: {
      get() {
        return this.data.maxSecretLevel + 1;
      },
      set(val) {
        this.data.maxSecretLevel = val - 1;
      },
    },
  },
  methods: {},
};
</script>

